import {Breadcrumbs} from '../breadcrumbs/breadcrumbs';
import i18n from '../../utilities/i18n';
import React, {Fragment} from 'react';
import {ErrorBox} from '../errorbox/errorbox';
import './ugyldigjeger.scss';
import {env_vars} from '../../utilities/load-env';

const UgyldigJeger = (props) => {
  return (
    <div className='container errorBoxMargin'>
      <article className='pagetitle'>
        <Breadcrumbs crumbKey="lisensjeger" title={i18n.t('felles:lisensjeger')}/>
        <h1>{i18n.t('titel:hovedTitel')}</h1>
      </article>
      <Fragment>
        <ErrorBox>
            {props.isVarsel ? (
                <>
                    <h3>{i18n.t('serverError:varsel')}</h3>
                    <p>{i18n.t('serverError:taKontaktPreLink')}
                    <a href={env_vars.BRREG_FORSIDE_URL + 'hvordan-kan-vi-hjelpe-deg/'} className='normal-br-link'>
                        {i18n.t('serverError:taKontaktLink')}
                    </a>{i18n.t('serverError:varselDetaljer')}</p>
                </>
            ) : (
                <>
                    <h3>{i18n.t('serverError:ugyldig')}</h3>
                    <p>{i18n.t('serverError:taKontaktPostLink')}</p>
                </>
            )}
        </ErrorBox>
      </Fragment>
    </div>
  );
};

export default UgyldigJeger;
